module.exports = __webpack_public_path__ + "static/media/ensuite-light.69ee3651.jpg";